import { type JSXElementConstructor, type ReactNode, Suspense } from 'react';

import { Spinner } from '@/components/common/loader';

export const MainLoaderSkeleton = () => {
  return (
    <div className="flex min-h-screen w-full items-center justify-center">
      <Spinner className="h-[50px] w-[50px] border-[6px]" />
    </div>
  );
};

export const withSuspense =
  (
    Component: JSXElementConstructor<any>,
    fallback: ReactNode = <MainLoaderSkeleton />
  ) =>
  ({ children }: { children?: ReactNode }) => (
    <Suspense fallback={fallback}>
      <Component>{children && children}</Component>
    </Suspense>
  );
